import axiosInstance from "../api/axiosInstance";

export const handleLogout = async (djId, token, navigate) => {
  try {
    await axiosInstance.patch(`/auth/${djId}/logout`, null, {
      headers: { Authorization: `Bearer ${token}` },
    });

    localStorage.removeItem("token");
    navigate("/login");
  } catch (error) {
    console.error("Logout error", error);
  }
};
